var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"wrap",staticClass:"lyrics-box nano"},[_c('div',{staticClass:"nano-content"},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLyricsAnimateLoading),expression:"!isLyricsAnimateLoading"}],ref:"lyricsBox",staticClass:"lyric-box"}),(_vm.isLyricsAnimateLoading)?_c('v-spinner'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }